import { jsx as _jsx } from "react/jsx-runtime";
import { formatPercentage } from '@cronos-app/utils';
import { forwardRef, useMemo } from 'react';
import { BasicNumber } from './BasicNumber';
export const Percentage = forwardRef(({ value: _value, minDigits, maxDigits, ...props }, ref) => {
    const value = useMemo(() => _value !== undefined
        ? formatPercentage(Number(_value), true, undefined, undefined, minDigits, maxDigits)
        : undefined, [_value, maxDigits, minDigits]);
    return _jsx(BasicNumber, { ...props, value: value, ref: ref });
});
Percentage.displayName = 'Percentage';
